<nb-card>
    <nb-card-header>Event Preview : {{view}}</nb-card-header>
    <nb-card-body>
      <div class="post-wrapper">
        <div [ngSwitch]="view" class="post-container">
          <span *ngSwitchCase="'FACEB_PROD_POST'">
              <div class="fb-post">
                  <!-- Post Header -->
                  <div class="fb-post-header">
                    <img src="https://placehold.co/150x150" alt="Profile Picture Placeholder" class="fb-profile-pic">
<!--                     <img src="https://via.placeholder.com/40" alt="Profile" class="fb-profile-pic"> -->
                    <div class="fb-post-info">
                      <span class="fb-user-name">Your Page Name</span>
                      <span class="fb-post-time">{{data?.start}}</span>
                    </div>
                  </div>
                
                  <!-- Post Content -->
                  <div class="fb-post-content">
                    <p class="fb-post-text">{{ data?.title }}</p>
                    <img [src]="imageUrl" alt="Post Image" class="fb-post-image">
                  </div>
                
                  <!-- Post Actions -->
                  <div class="fb-post-actions">
                    <button class="fb-btn">👍 Like</button>
                    <button class="fb-btn">💬 Comment</button>
                    <button class="fb-btn">🔄 Share</button>
                  </div>
                </div>
                
          </span>
          <span *ngSwitchCase="'twitter'">
          </span>
          <span *ngSwitchCase="'instagram'">
          </span>
          <span *ngSwitchCase="'linkedin'">
          </span>
        </div>
        <div>
          <form (ngSubmit)="onSubmit()">
            <div class="form-group">
              <label for="newImage">Update Image</label>
            </div>
            <div class="form-group">
              <input nbInput type="file" id="newImage" (change)="onFileChange($event)" />
            </div>
            <div class="form-group">
              <button nbButton status="primary" type="submit" size="small">Update Image</button>
            </div>
          </form>
        </div>
      </div>
        
        
      <!-- <div>
        <h4>Work Effort ID: {{ data.workEffortId }}</h4>
        <h5>Platform: {{ data.platform }}</h5>
        <h5>Title: {{ data.title }}</h5>
        <div>
          <img [src]="data.metaDataValue2" alt="Event Image" class="event-image" />
        </div>
        <form (ngSubmit)="onSubmit()">
          <label for="newImage">Update Image</label>
          <input type="file" id="newImage" (change)="onFileChange($event)" />
          <button nbButton status="primary" type="submit">Update Image</button>
        </form>
      </div> -->
    </nb-card-body>
  </nb-card>